




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  DxCheckBox,
  DxNumberBox,
  DxSwitch,
  DxTextBox,
  DxDateBox,
} from "devextreme-vue";
import notificationService from "@/services/notificationService";
import Popup from "@/components/default/Popup.vue";
import {
  InvoiceDto,
  InvoicePaidCommand,
  InvoicesClient,
  PaymentDto,
	EditInvoicePaidCommand,
} from "@/data/web-api-client";
import { constrainPoint } from "@fullcalendar/common";
import moment from "moment";

@Component({
  components: {
    DxCheckBox,
    DxNumberBox,
    DxSwitch,
    DxTextBox,
    DxDateBox,
    Popup,
  },
})
export default class InvoicePaymentDialog extends Vue {
  @Prop({ required: false })
  public paymentId?: string;
  @Prop({ required: false })
  public invoice?: InvoiceDto;

  public show: boolean = false;

	private payment?: PaymentDto;

	private invoiceId?: string;
  private remainingValue: number = 0;

  private value: number = 0;
  private ogm: string = "";
  private paymentDate: Date = new Date();

  private saving: boolean = false;
  private client: InvoicesClient = new InvoicesClient(undefined, this.$axios);

  private async mounted() {

    if (this.invoice) {
			this.invoiceId = this.invoice.id;
      this.value = this.invoice.toPay ? this.invoice.toPay : 0;
      this.remainingValue = this.invoice.toPay ? this.invoice.toPay : 0;

      this.ogm =
        this.invoice && this.invoice.paymentNote
          ? this.invoice.paymentNote
          : "";
    }
  }

  private hideDialog() {
    this.show = false;
		this.$emit("closed");
  }

  private async save() {
    try {
      this.saving = true;
      let upsertPromise: Promise<PaymentDto>;

      const today = new Date();

      this.paymentDate.setHours(today.getHours());
      this.paymentDate.setMinutes(today.getMinutes());
      this.paymentDate.setSeconds(today.getSeconds());
      this.paymentDate.setMilliseconds(today.getMilliseconds());

			if (this.paymentId) { //edit
        upsertPromise = this.client.editPaid(
          new EditInvoicePaidCommand({
            id: this.paymentId!,
						invoiceId: this.invoiceId!,
            amount: this.value,
            paymentDate: this.paymentDate,
            ogm: this.ogm,
						setInvoiceAsPaid: this.fullyPaid,
          })
        );

      } else { //create
        upsertPromise = this.client.paid(
          new InvoicePaidCommand({
            id: this.invoiceId!,
            amount: this.value,
            paymentDate: this.paymentDate,
            ogm: this.ogm,
						setInvoiceAsPaid: this.fullyPaid,
          })
        );
      }
      upsertPromise.finally(() => {
					notificationService.saved();
					this.$emit("updated");
					this.hideDialog();
				}
			)
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  private get fullyPaid() {
    return this.invoice && this.invoice.toPay && this.value
      ? (this.payment && this.payment.amount ? this.value >= (this.payment.amount + this.invoice.toPay) : this.value >= this.invoice.toPay)
      : this.value ? true : false;
  }

  private convertDate(date: Date) {
    return moment(date).format("DD-MM-YYYY HH:mm");
  }

  private addRemaningAmount() {
		if (this.paymentId && this.payment && this.payment.amount) {
			if (!this.value) {
				this.value = this.payment.amount + this.remainingValue;
			}
			this.value = this.payment.amount && ((this.payment!.amount + this.remainingValue) !== this.value) ? this.value + this.remainingValue : this.value;
			return;
		}
		this.value = this.remainingValue;

  }

  @Watch("invoice", { deep: true })
  onInvoiceChange() {
    this.value = this.invoice && this.invoice.toPay ? this.invoice.toPay : 0;
  }

	@Watch('paymentId', {immediate: true})
	async onSelectedPaymentChanged() {
		if (this.paymentId) {
      this.payment = await this.client.getPayment(this.paymentId);
      this.value = this.payment.amount ? this.payment.amount : 0;
      this.ogm = this.payment.ogm ? this.payment.ogm : "";
      this.paymentDate = this.payment.paymentDate ? this.payment.paymentDate : new Date();
			if (!this.invoiceId) {
				this.invoiceId = this.payment.invoiceId;
			}
    }
	}
}
